export const dealImportEn = {
  button: "Import deals",
  title: "Import deals (CSV)",
  help: "Columns: company, phone, deal, stage, amount, source, category, loss_reason, loss_reason_detail, created_at (YYYY-MM-DD), expected_closing_date, rep (email). Re-importing skips deals already present.",
  file: "CSV file",
  totals: "Totals by stage",
  stage: "Stage",
  count: "Deals",
  amount: "Amount",
  issue: "Line %{line}: %{reason}",
  run: "Import %{smart_count} deal |||| Import %{smart_count} deals",
  summary:
    "%{created} created, %{skipped} already present, %{rejected} rejected.",
  close: "Close",
  forbidden: "Import is limited to administrators.",
  failed: "Import failed.",
  ignored:
    "%{smart_count} line will be ignored. |||| %{smart_count} lines will be ignored.",
  rejected: "Rejected rows",
  line: "Line",
  deal: "Deal",
  company: "Company",
  reason: "Reason",
  reasons: {
    missing_column: "required column missing: %{column}",
    extra_columns: "more columns than the header",
    malformed_row: "malformed line",
    invalid_category: "unknown category",
    invalid_email: "invalid email",
    missing_company: "missing company",
    missing_name: "missing deal name",
    invalid_stage: "unknown stage",
    invalid_amount: "invalid amount (whole dollars)",
    invalid_source: "unknown source",
    invalid_loss_reason: "unknown loss reason",
    loss_reason_required: 'loss reason required for "Lost"',
    loss_detail_required: 'detail required for reason "Other"',
    invalid_date: "invalid date (YYYY-MM-DD)",
    company_ambiguous: "several companies have this name",
  },
};
